package dev.kuml.portal.web.editor

/**
 * Client-seitige Vorpruefung des Beanstandungs-/Kommentar-Texts (R-9) -- reine Bequemlichkeit,
 * exakt wie [AiContextFile]s eigene Groessen-/Formatpruefung: massgeblich ist immer die
 * Server-Validierung (`dev.kuml.portal.server.generations.ReportTextValidator`). Die Konstante
 * wird bewusst gespiegelt, nicht geteilt (dieses Modul haengt nicht an `commonMain`, siehe
 * `build.gradle.kts`).
 */
public object GenerationReportText {
    public const val MAX_CHARACTERS: Int = 2_000

    /** `true` if [raw], trimmed, is non-empty and at most [MAX_CHARACTERS]. */
    public fun isSubmittable(raw: String): Boolean {
        val trimmed = raw.trim()
        return trimmed.isNotEmpty() && trimmed.length <= MAX_CHARACTERS
    }

    /** Remaining characters (may be negative once over the limit) -- for a live counter. */
    public fun remaining(raw: String): Int = MAX_CHARACTERS - raw.trim().length
}
